import { render, staticRenderFns } from "./task-report-newpannel.vue?vue&type=template&id=c19fa684&scoped=true&"
import script from "./task-report-newpannel.vue?vue&type=script&lang=js&"
export * from "./task-report-newpannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19fa684",
  null
  
)

export default component.exports